import React, { ChangeEvent, useContext, useEffect, useState } from "react";
import IIntakeForm from "../../../models/IIntakeForm";
import OwTitle from "../../shared/OwTitle/OwTitle";
import OwButton from "../../shared/OwButton/OwButton";
import OwLabel from "../../shared/OwLabel/OwLabel";
import { OwFnInput } from "../../shared/OwFnInput/OwFnInput";
import INewIntakeForm from "../../../models/INewIntakeForm";
import INewIntakeFormField from "../../../models/INewIntakeFormField";
import IProcessIntakeFormDTO from "../../../models/DTO/IProcessIntakeFormDTO";
import UserContext from "../../../contexts/UserContext";
import SupplierContext from "../../../contexts/SupplierContext";
import { SocketContext } from "../../../contexts/SocketContext";
import EndpointsEnum from "../../../models/EndpointsEnum";
import IOnProcessIntakeFormDTO from "../../../models/DTO/IOnProcessIntakeFormDTO";
import INotification from "../../../models/INotification";
import NotificationLevelEnum from "../../../models/NotificationLevelEnum";
import NotificationPositionEnum from "../../../models/NotificationPositionEnum";
import UiContext from "../../../contexts/UiContext";
import IUiSocketSetup from "../../../models/IUiSocketSetup";

type Props = {
    form?: IIntakeForm;
    closeFn: () => void;
};

export const IntakeFormSidebar = (props: Props) => {
    const userModel = useContext(UserContext);
    const supplierModel = useContext(SupplierContext);
    const socket = useContext(SocketContext)!;
    const uiContext = useContext(UiContext);

    const [form, setForm] = useState<Partial<INewIntakeForm>>(
        props.form || ({ name: "", success_url: "", error_url: "" } as Partial<INewIntakeFormField>)
    );
    const [fields, setFields] = useState<{ guid?: string; name: string; deleteFlag?: boolean }[]>(props.form?.Intake_Form_Fields || []);
    const [field, setField] = useState("");

    const handleChange = (e: ChangeEvent<any>) => {
        const { name, value } = e.target;

        if (name === "field") {
            setField(value);
            return;
        } else if (name === "success_url") {
            setForm({ ...form, success_url: value });
        } else {
            setForm({ ...form, [name]: value });
            return;
        }
    };

    const addField = () => {
        console.log(field);
        if (field) {
            const newField: Partial<INewIntakeFormField> = {
                name: field,
            };

            // @ts-expect-error
            setFields([...fields, newField]);
            setField("");
        }
    };

    const saveForm = () => {
        const payload: IProcessIntakeFormDTO = {
            // @ts-expect-error
            form,
            fields,
            userToken: userModel.token,
            userGuid: userModel.guid,
            supplierGuid: supplierModel.guid,
        };

        socket.emit(EndpointsEnum.IntakeFormProcess, payload);
    };

    const onSaveForm = (data: IOnProcessIntakeFormDTO) => {
        const notification: INotification = {
            message: "successfully_processed_intake_form",
            level: NotificationLevelEnum.success,
            position: NotificationPositionEnum.bc,
        };

        uiContext.notifyFn(null, notification);

        props.closeFn();
    };

    const sockets: IUiSocketSetup[] = [{ endpoint: EndpointsEnum.IntakeFormOnProcess, fn: onSaveForm }];

    useEffect(() => {
        for (const _socket of sockets) {
            socket.on(_socket.endpoint, _socket.fn);
        }

        return () => {
            for (const _socket of sockets) {
                socket.removeListener(_socket.endpoint, _socket.fn);
            }
        };
    }, []);

    const removeField = (_field: { guid?: string; name: string }) => {
        if (_field.guid) {
            for (const existingField of fields) {
                if (existingField.guid === _field.guid) {
                    existingField.deleteFlag = true;
                }
            }

            setFields([...fields]);
        } else {
            const newFields = fields.filter((existingField) => existingField.name !== _field.name);
            setFields(newFields);
        }
    };

    return (
        <div className={"IntakeFormSidebar p-2"}>
            <div className={"d-flex justify-content-between"}>
                <OwTitle title={props.form?.name || "new_form"} disableTranslation={!!props.form} />
                <div>
                    <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={props.closeFn} />
                </div>
            </div>

            <div className="mt-2">
                <div>
                    <OwLabel title={"name"} />
                    <OwFnInput fn={handleChange} name={"name"} value={form.name} />
                </div>

                <div className={"mt-2"}>
                    <OwLabel title={"success_url"} />
                    <OwFnInput fn={handleChange} name={"success_url"} value={form.success_url} />
                </div>

                <div className="mt-4 d-flex align-items-center">
                    <OwLabel title={"field"} className={"me-2"} />
                    <OwFnInput fn={handleChange} name={"field"} className={"ms-2"} value={field} />
                    <div>
                        <OwButton className={"ms-2 btn-primary"} title={"add"} fn={addField} />
                    </div>
                </div>
            </div>

            <div className="mt-2">
                <hr />
            </div>

            <div className="mt-2">
                <OwLabel title={"fields"} />
                <div>
                    {fields
                        .filter((_field) => !_field.deleteFlag)
                        .map((_field) => {
                            return (
                                <div key={_field.name} className={"d-flex justify-content-between"}>
                                    <span>
                                        <i
                                            className={"fad fa-trash-alt text-danger pointer"}
                                            onClick={() => {
                                                removeField(_field);
                                            }}
                                        />{" "}
                                        {_field.name}
                                    </span>
                                </div>
                            );
                        })}
                </div>
            </div>

            <div className="mt-2">
                <OwButton title={"save"} fn={saveForm} />
            </div>
        </div>
    );
};
